import { PasswordRecoverySteps } from "./types";

export const RESEND_COOL_DOWN = 60;

export const passwordRecoveryTitlesMap: Record<PasswordRecoverySteps, string> = {
  [PasswordRecoverySteps.PHONE_NUMBER_STEP]: "enterPhoneTitle",
  [PasswordRecoverySteps.SMS_CODE_STEP]: "enterCodeTitle",
  [PasswordRecoverySteps.NEW_PASSWORD_STEP]: "enterNewPasswordTitle",
  [PasswordRecoverySteps.SUCCESS_STEP]: "successTitle",
};
